import { useState, useEffect } from 'react';
import '../App.css';

function Popup(props) {

    function Reset() {
        window.location.href = window.location.href
    }

    const [stake, setStake] = useState(0)
    const [profit, setProfit] = useState(0)


    var red = [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3];
    var black = [15, 4, 2, 17, 6, 13, 11, 8, 10, 24, 33, 20, 31, 22, 29, 28, 35, 26];

    let i = 1
    var even = []
    var odd = []
    while (i <= 36) {
        if (i % 2 == 0) {
            even.push(i)
        } else {
            odd.push(i)
        }
        i++
    }

    var sideValues = props.sideValues;


    useEffect(() => {

        var winnerArray = props.numbers[props.winnerValue - 1]

        /* GET STAKE */

        var allBets = [];
        var stakeCount = 0

        props.numbers.forEach(element => {
            if (element.values && element.values.length > 0) {
                element.values.forEach(el => {
                    if (el.position !== 'side_1_18') {
                        allBets.push(el)
                    }
                })
            }
        });

        var isFindEvenOdd = false;

        allBets.forEach(element => {
            if (element.position == 'center') {
                stakeCount = stakeCount + element.value
            }

            if (element.position == 'four') {
                stakeCount = stakeCount + element.value
            }

            if (element.position == 'top') {
                stakeCount = stakeCount + element.value

            }

            if (element.position == 'side') {
                if (element.calculated === 8 || element.calculated === 18) {
                    return false
                } else {
                    stakeCount = stakeCount + element.value
                }
                
            }

            if (element.position == 'right') {
                stakeCount = stakeCount + element.value
            }

        })

        sideValues.forEach(element => {
            if (element.name !== 'zero' && element.name !== 'db_zero' || element.name !== 'zero') {
                stakeCount = stakeCount + element.value;
            } else {
                stakeCount = stakeCount + element.value
            }
        })

        setStake(stakeCount)


        /* WINNING VALUE FIXES */

        var profitValue = 0;
        var minus = 0;

        function allBetsFind(position) {
            return allBets.find(e => e.position === position)
        }
        if (allBetsFind("center") !== undefined) {
            if (allBets.length === 1) {

                if (props.winnerValue == allBetsFind("center").number) {
                    profitValue = allBetsFind("center").calculated;
                } else {
                    minus = minus - allBetsFind("center").value
                    profitValue = 0;
                }
            } else {
                var num = allBets.filter(e => e.position === 'center')

                num.forEach(element => {
                    if (props.winnerValue == element.number) {
                        profitValue = profitValue + (allBetsFind('center').value * 35)
                    }
                })
            }
        }

        allBets.forEach(element => {
            if (props.winnerValue == element.number) {
                if (element.position == 'top' || element.position == 'side' || element.position == 'four' || element.position == 'right') {
                    profitValue = profitValue + element.calculated
                }
            } else {
                if (element.position == 'top' || element.position == 'side' || element.position == 'four' || element.position == 'right' || element.position == 'center') {
                    if (element.position == 'side' && element.calculated === 8 || element.position == 'side' && element.calculated === 18) {
                        return false
                    } else {
                        minus = minus - element.value
                    }
                    
                }
            }
        })
        if (allBets.filter(e => e.position === 'center').length === 1) {
            minus = minus + allBetsFind("center").value
        }

        /* SIDEBAR */

        var first = [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
        var second = [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35]
        var third = [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33]

        if (sideValues.find(e => e.value > 0) !== undefined) {
            sideValues.forEach(element => {
                if (element.value > 0) {
                    if (element.name == 'db_zero' || element.name == 'zero') {
                        profitValue = profitValue + (element.value * 35)
                    } else if (element.name === '2to1_first') {
                        profitValue = profitValue + (element.value * 2)
                    } else if (element.name === '2to1_second') {
                        profitValue = profitValue + (element.value * 2)
                    } else if (element.name === '2to1_third') {
                        profitValue = profitValue + (element.value * 2)
                    }
                    else {
                        profitValue = profitValue + element.value
                    }
                }
            })

        }

        var winnerValue = props.winnerValue

        //RED

        if (red.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[3].value
            minus = minus - sideValues[3].value
        }

        //BLACK

        if (black.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[4].value
            minus = minus - sideValues[4].value
        }

        //1to18

        if (winnerValue < 19 && winnerValue > 0) {

        } else {

            profitValue = profitValue - sideValues[0].value
            minus = minus - sideValues[0].value
        }

        //even

        if (even.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[2].value
            minus = minus - sideValues[2].value
        }

        //odd

        if (odd.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[6].value
            minus = minus - sideValues[6].value
        }

        //19to36

        if (winnerValue > 19 && winnerValue < 37) {

        } else {
            profitValue = profitValue - sideValues[7].value
            minus = minus - sideValues[7].value
        }

        //1st12

        if (winnerValue > 0 && winnerValue < 13) {
            if (sideValues[1].value !== 0) {
                profitValue = (sideValues[1].value * 2)
            }

        } else {
            profitValue = profitValue - sideValues[1].value
            minus = minus - sideValues[1].value
        }

        //2nd12

        if (winnerValue > 12 && winnerValue < 25) {
            if (sideValues[5].value !== 0) {
                profitValue = (sideValues[5].value * 2)
            }

        } else {
            profitValue = profitValue - sideValues[5].value
            minus = minus - sideValues[5].value
        }

        //3rd12

        if (winnerValue > 24 && winnerValue < 37) {
            if (sideValues[8].value !== 0) {
                profitValue = (sideValues[8].value * 2)
            }

        } else {
            profitValue = profitValue - sideValues[8].value
            minus = minus - sideValues[8].value
        }

        /* zero */

        if (winnerValue != 38) {

            profitValue = profitValue - (sideValues[12].value * 35)
            minus = minus - sideValues[12].value
        }

        /* double zero */

        if (winnerValue != 37) {

            profitValue = profitValue - (sideValues[13].value * 35)
            minus = minus - sideValues[13].value
        }



        //2to1first


        if (first.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[9].value
            minus = minus - sideValues[9].value
        }

        //2to1second



        if (second.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[10].value
            minus = minus - sideValues[10].value
        }

        //2to1third



        if (third.find(e => e == winnerValue) === undefined) {
            profitValue = profitValue - sideValues[11].value
            minus = minus - sideValues[11].value
        }

        if (first.find(e => e == winnerValue) !== undefined) {
            //виграш 1
            profitValue = profitValue - (sideValues[10].value + sideValues[11].value)
        } else if (second.find(e => e == winnerValue) !== undefined) {
            //виграш 2
            profitValue = profitValue - (sideValues[9].value + sideValues[11].value)
        } else if (third.find(e => e == winnerValue) !== undefined) {
            //виграш 3
            profitValue = profitValue - (sideValues[9].value + sideValues[10].value)
        }

        /*



        /* END */

        var result = profitValue + minus

        setProfit(result)

    }, [props.numbers])


    return (
        <div className='popupWrapper'>
            <div className="popup">

                <div className="popupClose">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => props.visible(false)}>
                        <g clip-path="url(#clip0_68_2311)">
                            <path d="M0.420898 11.75L11.9209 0.25" stroke="#6A6A6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.420898 0.25L11.9209 11.75" stroke="#6A6A6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_68_2311">
                                <rect width="12" height="12" fill="white" transform="translate(0.170898)" />
                            </clipPath>
                        </defs>
                    </svg>

                </div>

                <div className="popupBody stake">
                    <p>Stake</p>
                    <p className='stakeCount'>${stake}</p>
                </div>

                <div className="popupBody profit">
                    <p>Profit/Loss</p>
                    <p className='profitCount'>
                        {
                            profit > 0
                                ? `+$${profit}`
                                : profit === NaN
                                    ? `$0`
                                    : `-$${profit.toString().replace('-', '')}`
                        }
                    </p>
                </div>

                <div className="resetWrapper">
                    <button className='resetButton' onClick={e => Reset()}>Reset Table</button>
                </div>

            </div>
        </div>
    );
}

export default Popup;